module.exports = __webpack_public_path__ + "static/media/optimisation-icon.0e27e0bc.svg";